import { TypeGenerator } from '../utils/type';
import { IArgumentType } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';


// 日期上指定的值
export function ALIGNED_WEEK_OF_MONTH(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;

  if (args.length !== 1) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的接受一个参数`, token.position);
  }

  if (!['Date', 'DateTime'].includes(args[0].type)) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的参数必须为 Date 或 DateTime 类型`, token.position);
  }


  // if (!isInteger(args[1], false)) {
  //   throw new InferenceError('function-argument-error', `${functionName} 函数的第二个参数必须为 Integer 类型`, token.position);
  // }


  return TypeGenerator.Integer();
}
